import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import GradientLegend from './GradientLegend';
import IconButton from './IconButton';

class ExpandableLegend extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    gradientInfo: PropTypes.shape(GradientLegend.propTypes),
    onPaddleLeft: PropTypes.func.isRequired,
    onPaddleRight: PropTypes.func.isRequired,
    isBusy: PropTypes.bool.isRequired,
  };

  state = {
    isCollapsed: false,
    animationEnabled: false,
  }

  togglePressed() {
    this.setState({
      animationEnabled: true,
      isCollapsed: !this.state.isCollapsed,
    });
  }

  leftPaddlePressed() {
    this.setState({animationEnabled: false});
    this.props.onPaddleLeft();
  }

  rightPaddlePressed() {
    this.setState({animationEnabled: false});
    this.props.onPaddleRight();
  }

  renderGradientLegend() {
    return (
      <GradientLegend {...this.props.gradientInfo} />
    );
  }

  renderCollection() {
    const children = React.Children.toArray(this.props.children);
    const expandedHeight = children.length * 41;
    const collectionStyle = {
      height: this.state.isCollapsed ? 0 : `${expandedHeight}px`,
    };
    return (
      <div className="ExpandableLegend__collection" style={collectionStyle}>
        {children}
      </div>
    );
  }

  renderToggleButton() {
    return (
      <button
        className="ExpandableLegend__toggleButton"
        onClick={::this.togglePressed}
      />
    );
  }

  render() {
    const numChildren = React.Children.count(this.props.children);
    return (
      <div
        className={classNames("ExpandableLegend", {
          'ExpandableLegend--collapsed': this.state.isCollapsed,
          'ExpandableLegend--animatedToggle': this.state.animationEnabled,
        })}
      >
        <div className="ExpandableLegend__container">
          <div>
            <div className="ExpandableLegend__header">
              <IconButton
                styleName="ExpandableLegend__paddleLeft"
                isBusy={this.props.isBusy}
                onClick={::this.leftPaddlePressed}
              />
              <span className="ExpandableLegend__title">{this.props.title}</span>
              <IconButton
                styleName="ExpandableLegend__paddleRight"
                isBusy={this.props.isBusy}
                onClick={::this.rightPaddlePressed}
              />
            </div>
            <p className="ExpandableLegend__description">
              {this.props.description}
            </p>
            {this.props.gradientInfo && this.renderGradientLegend()}
          </div>
          {numChildren > 0 && this.renderCollection()}
        </div>
        {numChildren > 0 && this.renderToggleButton()}
      </div>
    );
  }
}

export default ExpandableLegend;



// WEBPACK FOOTER //
// ./src/components/ExpandableLegend.js